import { STORAGE } from '../api/common/config.js'

const storage = {
	getSession: function (key) {
		let sessionFormData = sessionStorage.getItem(key)
		if (!sessionFormData) {
			return null
		} else {
			return JSON.parse(sessionFormData)
		}
	},

	setSession: function (key, data) {
		sessionStorage.setItem(key, JSON.stringify(data))
	},

	clearSession: (key) => {
		sessionStorage.removeItem(key)
	},

	setAttachments: (data) => {
		var attachments = storage.getSession(STORAGE.ATTACHMENTS)

		let isDupFile = false

		if (attachments == null) {
			attachments = []
		} else {
			attachments.forEach((file) => {
				if (file.fileName == data.fileName) {
					file = data
					isDupFile = true
				}
			})
		}

		if (!isDupFile) {
			attachments.push(data)
		}

		storage.setSession(STORAGE.ATTACHMENTS, attachments)
	},

	getAttachments: function () {
		var attachments = storage.getSession(STORAGE.ATTACHMENTS)
		return attachments
	},

	isApplyOrPaymentCompleted: function () {
		return storage.getSession(STORAGE.APPLY_PAYMENT_SUCCESS) || false
	},
}

export default storage
